// components/AuthListener.tsx
"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useLogout } from "@/apiUtilities/mutations/useLogout";


export function AuthListener() {
  const router = useRouter();
  const logout = useLogout();

  useEffect(() => {
    const handler = () => {
      console.log('Unauthorized handler')
      logout.mutateAsync();
    };

    window.addEventListener("unauthorized", handler);

    return () => {
      window.removeEventListener("unauthorized", handler);
    };
  }, [logout, router]);

  return null
}